import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = 'user' | 'admin';

export type ThemeMode = 'light' | 'dark';

export interface Profile {
  id: string;
  email: string;
  full_name: string;
  avatar_url?: string;
  company?: string;
  bio?: string;
  created_at: string;
  updated_at: string;
  first_name?: string;
  last_name?: string;
  profile_image_url?: string;
  phone?: string;
  instagram_url?: string;
  tiktok_url?: string;
  facebook_url?: string;
  linkedin_url?: string;
  short_bio?: string;
  story?: string;
  target_audience?: string;
  product_focus?: string;
  consulting_style?: string;
  city?: string;
  country?: string;
  language?: string;
  imprint_text?: string;
  role: UserRole;
  is_suspended: boolean;
  admin_notes?: string;
  // User settings
  primary_color?: string;
  theme_mode?: ThemeMode;
  menu_order?: string[];
  hidden_menu_items?: string[];
}
